import axios from 'axios'
import { API_BASE_URL, API_CONFIG } from '../config/api'

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: API_CONFIG.timeout,
  headers: API_CONFIG.headers,
})

let accessToken: any = localStorage.getItem('accessToken');

export const setAccessToken = (token: any) => {
  accessToken = token;
  if (token) {
    localStorage.setItem('accessToken', token);
  } else {
    localStorage.removeItem('accessToken');
  }
};

// Add JWT token interceptor
apiClient.interceptors.request.use((config) => {
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`
  }
  return config
})

// Add response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const url = error.config?.url;
    if (url?.includes("/login")) {
      return Promise.reject(error);
    }
    if (error.response?.status === 401) {
      setAccessToken(null);
      window.location.href = '/Login'
    }
    return Promise.reject(error)
  }
)